export default __webpack_public_path__ + "static/media/37.611e0f2d.png";